import { Box, Drawer, List, ListItem, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useCurrentUser } from "../app/useCurrentUser";

interface NavdrawerProps {
  open: boolean;
  onClose: () => void;
}

const Navdrawer = (props: NavdrawerProps) => {
  const [, isTenantAdmin] = useCurrentUser();
  const ListItemLink = (liprops: { to: string; label: string }) => {
    return (
      <ListItem
        button
        onClick={props.onClose}
        component={Link}
        to={liprops.to}
        sx={{
          "&:hover": {
            color: "primary.dark",
          },
          px: 6,
          py: 2,
        }}
      >
        <Link
          to={liprops.to}
          onClick={props.onClose}
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <Typography sx={{ fontSize: "1.1em" }}>{liprops.label}</Typography>
        </Link>
      </ListItem>
    );
  };
  return (
    <>
      <Drawer
        open={props.open}
        onClose={props.onClose}
        sx={{
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            maxWidth: "85vw",
            zIndex: (theme) => theme.zIndex.appBar - 1,
          },
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          sx={{
            pt: 8,
          }}
          height={"calc(100% - 18px)"}
          justifyContent="space-between"
          alignItems="center"
        >
          <List>
            <ListItemLink to="/users" label="Users" />
            {isTenantAdmin && <ListItemLink to="/roles" label="Roles" />}
            {isTenantAdmin && <ListItemLink to="/organizations" label="Organizations" />}
          </List>
        </Box>
      </Drawer>
    </>
  );
};
export default Navdrawer;
